var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftIllustration = function SvgGiftIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift-illustration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4D8FE",
    d: "M14 27.125c4.442 0 7.52-.172 9.416-.331 1.818-.152 3.263-1.515 3.44-3.361.14-1.444.269-3.576.269-6.517 0-2.94-.129-5.072-.268-6.516-.178-1.846-1.623-3.209-3.44-3.361-1.898-.16-4.976-.331-9.417-.331s-7.52.172-9.416.33C2.766 7.19 1.32 8.555 1.144 10.4c-.14 1.444-.269 3.576-.269 6.516s.129 5.073.268 6.516c.178 1.847 1.623 3.21 3.44 3.362 1.898.16 4.975.33 9.417.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7DFD",
    fillRule: "evenodd",
    d: "M8.167 2.916c-1.374 0-2.334 1.021-2.334 2.334 0 .646.262 1.229.687 1.653-.747.043-1.39.09-1.936.136-.233.019-.46.058-.678.116A4.651 4.651 0 0 1 3.5 5.25C3.5 2.696 5.457.583 8.167.583c2.123 0 3.864.974 5.054 2.164.283.284.545.59.779.91a7.77 7.77 0 0 1 .78-.91c1.19-1.19 2.93-2.164 5.053-2.164 2.71 0 4.667 2.113 4.667 4.667a4.65 4.65 0 0 1-.406 1.905 3.951 3.951 0 0 0-.678-.116 73.748 73.748 0 0 0-1.936-.136 2.323 2.323 0 0 0 .687-1.653c0-1.313-.96-2.334-2.334-2.334-1.376 0-2.552.63-3.404 1.482-.894.893-1.262 1.853-1.262 2.31v.004a168.05 168.05 0 0 0-2.334 0v-.004c0-.457-.368-1.417-1.262-2.31-.852-.852-2.028-1.482-3.404-1.482Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7DFD",
    d: "M12.833 27.12V6.713c.778-.005 1.556-.005 2.333 0v20.409c-.777.005-1.555.005-2.333 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7DFD",
    d: "M.882 18.083h26.236c.01-.777.01-1.555 0-2.333H.882c-.01.778-.01 1.556 0 2.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift-illustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgGiftIllustration;